const PADDING_SIZE = {
  xs: 1,
  md: 2,
  lg: 3,
  xlg: 4,
};

export {PADDING_SIZE};
